<template>

  <div>
    <div v-if="timeOut">

      <div class="alert alert-info"><h5 class="pt-2">{{ $t('text.auditLog.internalAuditLog.lotsOfData') }}</h5>
        <p>
          <a :id="'report' + section + 'LogBtn'" class="btn btn-primary btn-sm text-white mt-3 mb-2"
             @click="generateReport()" v-if="section !== 'Grouped'"><i class="far fa-file-alt"></i>
            &nbsp;{{ $t('text.auditLog.internalAuditLog.lotsOfDataReport') }}</a>
        </p>
      </div>

    </div>
    <div v-if="!timeOut">
      <div class="alert alert-info" v-if="entries.length === 0"><h5 class="pt-2">
        <em>{{ $t('text.globals.noOptions') }}</em></h5></div>

      <div v-if="entries.length > 0" class="float-right">
      <a :id="'export' + section + 'LogBtn'" @click="saveFile"
         v-if="$globalFunctions.checkForPermission('IZVOZ_REVIZ_SLED')"
         class="btn btn-primary btn-sm text-white mt-2 mb-2 float-right"><i class="fa fa-download"></i>
        {{ $t('text.globals.export') }}</a>


      <a :id="'report' + section + 'LogBtn'" class="btn btn-primary btn-sm text-white m-2 float-right"
         @click="generateReport()" v-if="section !== 'Grouped'"><i class="far fa-file-alt"></i>
        {{ $t('text.auditLogTable.report') }}</a>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>

      <table class="table auditLogResults searchResults" v-if="entries.length > 0">
        <thead>
        <tr>
          <th style="width: 35px;">#</th>
          <th style="width: 250px;">{{ ($t('text.auditLogTable.time')) }}</th>
          <th>{{ $t('text.auditLogTable.user') }}</th>
          <th>{{ $t('text.auditLogTable.role') }}</th>
          <th>{{ $t('text.auditLogTable.event') }}</th>
          <th style="width: 130px;">{{ $t('text.auditLogTable.details') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in entries" :key="'item_' + index">
          <td style="width: 35px;" class="text-muted">{{ index + 1 }}</td>
          <td style="width: 250px;">
            <!-- {{moment(item.time).format('DD. MM. YYYY HH:mm:ss')}}-->
            {{ moment((item.time)).local().format('dddd, DD. MM. YYYY, HH:mm:ss') }}
          </td>
          <td>

                    <span v-if="item.application === 'RM'">
                        {{ item.user ? item.user : '' }}
                    </span>
            <span v-if="item.application === 'archeia'">
                        {{ item.user ? item.user : '' }}
                    </span>
            <span v-if="item.application === 'CMISChangeLog'">
                        {{ item.user ? item.user : '' }}
                    </span>
            <span v-if="item.application === 'ehramba'">
                        {{ item.user ? item.user : '' }}
                    </span>
          </td>
          <td>
                    <span v-if="item.application === 'RM'">
                        {{ item.values["/RM/event/person/roles"] ? item.values["/RM/event/person/roles"] : '' }}
                    </span>
          </td>
          <td>
                    <span v-if="item.application === 'RM'">
                        {{ item.values["/RM/event/name/value"] ? getReadableAuditKey(item.values["/RM/event/name/value"]) : '' }}
                    </span>
            <span v-if="item.application === 'archeia'">
                        {{ item.values["/archeia/transaction/action"] ? getReadableAuditKey(item.values["/archeia/transaction/action"]) : '' }}
                    </span>
            <span v-if="item.application === 'ehramba'">
                        {{ item.values["/ehramba/transaction/action"] ? getReadableAuditKey(item.values["/ehramba/transaction/action"]) : '' }}
                    </span>
          </td>
          <td style="width: 130px;">
            <a
                class="btn btn-outline-info text-info btn-sm p-1 ml-2"
                style="font-size: 12px" @click="showDetails(index)">{{ $t('text.auditLogTable.detailsLink') }}</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <b-modal ref="audit-details-modal" :title="$t('text.auditLogTable.auditDetailsModal.title')" size="xl">


      <div class="row">
        <div class="col-md-12 mb-0">
          <!--                    {{values}}-->

          <div class="table-responsive" v-if="values.length > 20">
            <table class="table auditLog" v-html="values"></table>
          </div>
          <div class="mt-2 mb-2 text-center" v-else>
            <em><i class="fa fa-exclamation-triangle"></i>
              {{ $t('text.auditLogTable.auditDetailsModal.noDetailsAvailable') }}</em>
          </div>

        </div>
      </div>


      <div slot="modal-footer" class="w-100">
        <b-button
            id="headerCloseModalButton1"
            variant="primary"
            class="float-right"
            @click="closeModal">
          {{ $t('text.globals.ok') }}
        </b-button>
      </div>

    </b-modal>
  </div>


</template>


<script>
import Vue from 'vue';
import {version} from '../../package';
import $ from 'jquery';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import JsonCSV from 'vue-json-csv';
import flatten from 'flat';
import GenerateReportButton from "./GenerateReportButton";

Vue.component('downloadCsv', JsonCSV)

export default {
  name: 'AuditLogTable',
  components: {
    Loading,
    JsonCSV,
    GenerateReportButton
  },
  props: ['entries', 'section', 'timeOut', 'searchUrlParams', 'postData', 'useOldApiEndpoint'],
  data() {
    return {
      labelValues: [],
      values: [],
      selectedItemIndex: null
    };
  },
  computed: {
    getDataToExport() {
      const _this = this;

      let entriesToExport = _.map(_this.entries, function (val) {
        if (val.values) {
          return flatten(val)
        }
      });


      console.log(entriesToExport);

      return entriesToExport;
    }
  },
  mounted() {
    const _this = this;

    _this.retrieveLabelValues();


  },
  methods: {

    saveFile() {
      const data = JSON.stringify(this.entries)
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents'),
          a = document.createElement('a');
      a.download = "izvoz_revizijske_sledi.json";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },

    retrieveLabelValues() {
      const _this = this;

      axios.get(config.codeLists + 'audit-dictionary')
          .then((res) => {

            console.log("res", res);
            _this.labelValues = res.data.body;

          })
          .catch((error) => {
            console.error(error);
          });

    },

    showDetails(index) {
      console.log(index);
      const _this = this;
      _this.selectedItemIndex = index;
      _this.getValues();
      _this.$refs['audit-details-modal'].show()
      // _this.$bvModal.show("audit-details-modal");
    },

    closeModal() {
      const _this = this;
      _this.selectedItemIndex = null;

      _this.$refs['audit-details-modal'].hide();
      // _this.$bvModal.hide('audit-details-modal');

    },

    getValues() {
      const _this = this;
      let values = _this.entries[_this.selectedItemIndex];
      _this.values = _this.objectToTable(values);
    },

    getReadableAuditKey(key) {
      const _this = this;

      let labelItem = _.filter(_this.labelValues, {key: key});

      if (labelItem.length) {
        return labelItem[0].value
      } else {
        return key
      }
    },

    objectToTable(obj) {
      const _this = this;

      let table = $('<table>').append('<tbody>');
      for (let key in obj) {
        let tr = $('<tr>');
        let th = $('<th>').append(_this.getReadableAuditKey(key));
        let td = $('<td>');
        let value;
        if (typeof (obj[key]) == 'object') {
          if (obj[key]) {
            value = _this.objectToTable(obj[key]);
          } else {
            value = '<span class="null">null</span>';
          }
        } else if (typeof (obj[key]) == 'boolean') {
          let str = (obj[key]) ? 'true' : 'false';
          value = '<span class="boolean">' + str + '</span>';
        } else if (typeof (obj[key]) == 'string') {

          console.log("key", key);
          console.log("obj[key]", obj[key]);

          if (key === '/alfresco-access/transaction/sub-actions' || key === '/archeia/transaction/sub-actions') {
            let subActionName = obj[key].split(' ');
            let subActionReadableName = [];

            _.map(subActionName, function (val) {
              subActionReadableName.push(_this.getReadableAuditKey(val));
            });

            value = '<span class="string">"' + subActionReadableName.join(', ') + '"</span>';

          } else {
            value = '<span class="string">"' + _this.getReadableAuditKey(obj[key]) + '"</span>';
          }

        } else {
          value = obj[key].valueOf();
        }
        td.append(value);
        tr.append(th).append(td);
        table.append(tr);
      }

      console.log("table", table);
      return '<table class="table">' + $(table).html() + '</table>';
    },

    generateReport() {
      const _this = this;

      let data = {
        "reportType": "REVIZIJSKA_SLED",
        "auditReportQuery": {
          "app": _this.section,
          "user": (_this.searchUrlParams && _this.searchUrlParams.user) ? _this.searchUrlParams.user : null,
          "from": (_this.searchUrlParams && _this.searchUrlParams.fromTime) ? _this.searchUrlParams.fromTime : null,
          "to": (_this.searchUrlParams && _this.searchUrlParams.toTime) ? _this.searchUrlParams.toTime : null,
          "limit": (_this.searchUrlParams && _this.searchUrlParams.limit) ? _this.searchUrlParams.limit : 500,
          "koncniUporabnikCert": (_this.searchUrlParams && _this.searchUrlParams.koncniUporabnikCert) ? _this.searchUrlParams.koncniUporabnikCert : null,
          "auditSearchQuery": _this.postData
        },
        "fromAlfresco": _this.useOldApiEndpoint
      };

      _this.$globalFunctions.generateReport(data, {dontWaitForResponse: false});
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AuditLogTable.vue